import { cva } from 'class-variance-authority'
import { ButtonBadge, ButtonProps } from './types'
import { Platform } from 'react-native'
import { IconName } from '@ui/elements/Icon'

export const sButton = cva('flex flex-row items-center rounded-full', {
  variants: {
    variant: {
      filled: '',
      outlined: '',
    },
    size: {
      lg: 'h-16 gap-4 px-8',
      md: 'h-12 gap-3 px-4',
      sm: 'h-10 gap-2 px-6',
      xs: 'h-8 gap-1 px-4',
    },
    width: {
      minimal: '',
      content: '',
      full: 'justify-between',
    },
    icon: {
      none: '',
      start: '',
      end: '',
      both: '',
      only: 'aspect-square flex-shrink-0',
    },
    disabled: { true: 'cursor-not-allowed', false: 'cursor-pointer' },
  },
  compoundVariants: [
    // outlined
    {
      variant: 'outlined',
      disabled: false,
      className: 'border-2 border-text',
    },
    // outlined xs border
    {
      variant: 'outlined',
      size: 'xs',
      disabled: false,
      className: 'border border-text/25',
    },
    // outlined disabled
    {
      variant: 'outlined',
      disabled: true,
      className: 'border-2 border-black/10',
    },
    // outlined xs border disabled
    {
      variant: 'outlined',
      size: 'xs',
      disabled: true,
      className: 'border border-black/0',
    },
    // lg iconStart
    {
      size: 'lg',
      icon: 'start',
      className: 'gap-4 pl-8 pr-12',
    },
    // lg iconEnd
    {
      size: 'lg',
      icon: 'end',
      className: 'gap-4 pl-12 pr-8',
    },
    // lg icon both
    {
      size: 'lg',
      icon: 'both',
      className: 'gap-4 px-8',
    },
    // lg icon none
    {
      size: 'lg',
      icon: 'none',
      className: 'px-12',
    },
    // lg icon only
    {
      size: 'lg',
      icon: 'only',
      className: 'w-16 justify-center px-0',
    },
    // md iconStart
    {
      size: 'md',
      icon: 'start',
      className: 'pl-4 pr-7',
      // className: 'pl-8 pr-8',
    },
    // md iconEnd
    {
      size: 'md',
      icon: 'end',
      className: 'pl-7 pr-4',
      // className: 'pl-8 pr-8',
    },
    // md icon both
    {
      size: 'md',
      icon: 'both',
      className: 'px-4',
    },
    // md icon none
    {
      size: 'md',
      icon: 'none',
      className: 'px-7',
    },
    // md icon only
    {
      size: 'md',
      icon: 'only',
      className: 'w-12 justify-center px-0',
    },
    // sm icon only
    {
      size: 'sm',
      icon: 'only',
      className: 'w-10 justify-center px-0',
    },
    // xs icon only
    {
      size: 'xs',
      icon: 'only',
      className: 'w-8 justify-center px-0',
    },
    // icon only disabled
    {
      icon: 'only',
      className: 'border border-black/10',
    },
    // icon only disabled
    {
      icon: 'only',
      disabled: true,
      className: 'border-text/0',
    },
  ],
  defaultVariants: {
    variant: 'filled',
    size: 'md',
  },
})

export const sText = cva('font-head-bold tracking-head', {
  variants: {
    variant: {
      filled: 'color-white',
      outlined: 'color-text',
    },
    size: {
      lg: [Platform.OS === 'web' ? 'text-[1.25rem]' : 'text-[20px]'],
      md: [Platform.OS === 'web' ? 'text-[1rem]' : 'text-[16px]'],
      sm: [Platform.OS === 'web' ? 'text-[0.875rem]' : 'text-[14px]'],
      xs: [
        'font-text-bold tracking-normal',
        Platform.OS === 'web' ? 'text-[0.875rem]' : 'text-[14px]',
      ],
    },
  },
  // compoundVariants: [
  //   {
  //     disabled: true,
  //     className: 'color-black opacity-25',
  //   },
  // ],
  defaultVariants: {
    variant: 'filled',
    size: 'md',
  },
})

export const badgeColor: Record<ButtonBadge, string> = {
  required: 'bg-red-500',
  optional: 'bg-blue-500',
}

export const iconSizes: Record<
  Exclude<ButtonProps['size'], null | undefined>,
  number
> = {
  xs: 20,
  sm: 24,
  md: 24,
  lg: 32,
}

export const getIconVariant = (
  icon1?: IconName,
  icon2?: IconName,
  isLabel?: boolean
) => {
  if (!isLabel) return 'only'
  if (icon1 && icon2) return 'both'
  if (icon1) return 'start'
  if (icon2) return 'end'
  return 'none'
}
